var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.render)?_c('div',{staticClass:"menu-wrapper"},[_c(_vm.compName,{tag:"component"}),_c('div',{staticClass:"label"},[_c('span',[_vm._v(_vm._s(_vm.menName))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }